import React, { useCallback, useEffect, useState } from "react";
import ConfirmModal from "../../../components/modal/confirmModal";
import FailModal from "../../../components/modal/failModal";
import SuccessModal from "../../../components/modal/successModal";
import { PAGES, PERMISSION_DATA } from "../../../lib/const";
import usePermission from "../../../lib/hooks/usePermisson";
import useTouchpoint from "../../../lib/hooks/useTouchpoint";
import {
  deleteTouchPoint,
  searchTouchPoint,
} from "../../../services/customerTouchPoint";
import { channelList, convertInstToID } from "./components/dataReport";
import Search from "./components/search";
import TableList from "./components/tableList";

const TouchPointCustomer = () => {
  const [permissionView, setPerssionView] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("คุณต้องการลบข้อมูล ?");
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [fetchData, setFetchData] = useState(true);

  // role user : permision
  const [roleUser, isAdmin] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.TOUCHPOINT
  );

  let [no, setNo] = useState(0);
  const {
    questionValues,
    setQuestionValues,
    headerValues,
    setHeaderValues,
    searchValues,
    setSearchValues,
    pageValues,
    setPageValues,
    search,
    setSearch,
  } = useTouchpoint();

  useEffect(() => {
    setPerssionView(roleUser[0]?.isView);

    //clear LocalStorage
    channelList.map((item) => {
      localStorage.removeItem(item);
    });
  }, [permissionView]);

  const fetchTouchPointCustomers = useCallback(
    async (searchValues, pageValues) => {
      // console.log("searchValues", searchValues);
      // console.log("pageValue==>s", pageValues);
      const res = await searchTouchPoint(searchValues, pageValues);
      const { objectValue, pageValue } = res.data;

      if (res?.data?.code === "0000") {
        // console.log("objectValue :: ", objectValue);
        setDataSource(objectValue);
        // setSearchValues(objectValue);
        setPageValues(pageValue);
      } else {
        setPageValues({
          page: 0,
          pageSize: 10,
          total: 0,
          totalPage: 0,
          sortBy: "createDate",
          sortDirection: "DESC",
        });
        setDataSource([]);
      }
    },
    [setDataSource, setSearchValues, setPageValues]
  );

  const onSearch = async (values) => {
    console.log("values", values);
    let checkListYear = "";
    let checkListQuarter = "";
    if (values.yearOfBudget) {
      values.yearOfBudget.map((item) => {
        if (item === "") {
          checkListYear = null;
        }
      });
    }
    if (values.quarterOfBudget) {
      values.quarterOfBudget.map((item) => {
        if (item === "") {
          checkListQuarter = null;
        }
      });
    }

    setSearch(true);
    setSearchValues({
      institutionId: values.institutionId
        ? convertInstToID(values.institutionId)
        : null,
      channel: values.channel ? values.channel : null,
      quarterOfBudget:
        checkListQuarter === null
          ? null
          : values.quarterOfBudget
          ? values.quarterOfBudget
          : null,
      yearOfBudget:
        checkListYear === null
          ? null
          : values.yearOfBudget
          ? values.yearOfBudget
          : null,
      groupsByNationality: values.groupsByNationality
        ? values.groupsByNationality
        : null,
      groupsByAge: values.groupsByAge ? values.groupsByAge : null,
      estateName: values.estateName ? values.estateName : null,
    });
    setPageValues({
      page: 0,
      pageSize: pageValues.pageSize,
      total: pageValues.total,
      totalPage: pageValues.totalPage,
      sortBy: pageValues.sortBy,
      sortDirection: pageValues.sortDirection,
    });
  };

  const onActionDelete = async (id) => {
    setConfirmLoading(true);
    setOpenModal(true);
    setConfirmLoading(false);
    setId(id);
  };

  const onDelete = async () => {
    try {
      const res = await deleteTouchPoint(id);
      if (res.data.code === "0000") {
        setSuccessModal(true);
        setSearch(true);
      } else {
        setFailModal(true);
      }
      setOpenModal(false);
      setConfirmLoading(false);
    } catch (error) {}
  };

  const handleCancel = () => {
    setOpenModal(false);
  };

  const onSorter = (pagination, filters, sorter) => {
    // console.log(sorter);
    setSearch(true);
    setPageValues((prev) => ({
      ...prev,
      sortBy: sorter && sorter.columnKey ? sorter.columnKey : "yearOfBudget",
      sortDirection:
        sorter && sorter.order
          ? sorter.order === "ascend"
            ? "ASC"
            : "DESC"
          : "ASC",
    }));
  };

  const onPageChange = (page, pageSize) => {
    //  setLoading(true);
    setSearch(true);
    setPageValues((prev) => ({
      ...prev,
      page: page - 1,
      pageSize: pageSize,
    }));
  };

  useEffect(() => {
    if (search) {
      fetchTouchPointCustomers(searchValues, pageValues);
      setSearch(false);
    }
  }, [fetchTouchPointCustomers, searchValues, pageValues, search, setSearch]);

  return (
    <React.Fragment>
      <Search onSearch={onSearch} roleUser={roleUser}></Search>
      <TableList
        dataSource={dataSource}
        permissionView={permissionView}
        isAdmin={isAdmin}
        setOpenModal={setOpenModal}
        onDelete={onActionDelete}
        setLoading={setLoading}
        setFetchData={setFetchData}
        onSorter={onSorter}
        onPageChange={onPageChange}
        roleUser={roleUser}
      ></TableList>
      <ConfirmModal
        title={"ยืนยันการลบข้อมูล"}
        open={openModal}
        modalText={modalText}
        onOk={onDelete}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        actionType={"delete"}
      />
      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal open={failModal} setOpen={setFailModal} />
    </React.Fragment>
  );
};

export default TouchPointCustomer;
